<script setup lang="ts">
    import { inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { DashboardAccess } from '@views/Dashboard/Dashboard.access';
    import UpdatesItem from './UpdatesItem.vue';
    import Loading from '@shared/components/Loading.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const dashboardAccess: DashboardAccess = injectorAccess.injector.get(DashboardAccess);
</script>

<template>
    <section>
        <h2 class="h4 m-0-t strong">{{ $Resources.ArchiveHeading }}</h2>

        <div class="card-1 p-lg-all" v-if="dashboardAccess.posts.value.length">
            <UpdatesItem v-for="(post, index) in dashboardAccess.posts.value" :key="index" :post="post" :index="index" />
        </div>

        <div class="form-group text-right" v-if="dashboardAccess.posts.value.length">
            <a href="/Updates" class="btn btn-link">
                {{ $Resources.ToArchiveLink }}
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </a>
        </div>

        <Loading :show="dashboardAccess.state.loadingDashboardPosts" loadingStyle="progress-bar" />
    </section>
</template>

<style scoped></style>
